import React from 'react';

import DiscountBlock from '../DiscountBlock';
import PriceBlock from '../PriceBlock';

const getBoletoInput = (props, plan, selectMethodPayment, i) => (
  <li key={props.paymentMethods[i].id} data-cy="method-bankslip">
    <button
      type="button"
      className={`${props.paymentMethods[1].class}  opcao`}
      onClick={() => selectMethodPayment(i, 'boleto', props)}
    >
      <div className='mobile-payment-card'>
        <div className="icon-payment-mobile">
          <img src={`/assets/images/pagamento/${props.paymentMethods[1].img}.svg`} alt="pagamento" />
        </div>
        <div className="infos-payment-mobile">
          <h4>{props.paymentMethods[i].name}</h4>
          <div className="text-payment-mobile">
            <div className="desc-info">Pague seu seguro viagem com o boleto e ganhe desconto</div>

            <DiscountBlock
              paymentMethods={props.paymentMethods}
              purchaseSummary={props.purchaseSummary}
              paymentMethodSlug="boleto"
            />
            <PriceBlock
              paymentMethods={props.paymentMethods}
              purchaseSummary={props.purchaseSummary}
              paymentMethodSlug="boleto"
            />

            <div className="small-payment">Exclusivo para pagamento no boleto</div>
          </div>
        </div>
      </div>
      <div className="advancer-payment-mobile">
        <div></div>
      </div>
    </button>
  </li>
);

export default getBoletoInput;



// WEBPACK FOOTER //
// ./src/components/purchase/payment_info/mobile/inputs/getBoletoInput.jsx